const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20style%20illustration%20with%20a%20beautiful%20couple%20under%20cherry%20blossoms%2C%20soft%20pastel%20warm%20colors%2C%20dreamy%20atmosphere%2C%20delicate%20art%20style%2C%20spring%20romance%20theme%2C%20ethereal%20lighting&width=500&height=700&seq=card-manga-01&orientation=portrait',
    title: '恋爱幻想曲',
    tag: '韩漫·恋爱',
    status: '连载中',
    update: '今日更新',
    desc: '命运的红线跨越时空，两个灵魂的浪漫邂逅。唯美画风，每一帧都如壁纸般精致。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20Japanese%20shonen%20manga%20cover%20style%20with%20a%20heroic%20character%20wielding%20a%20magical%20sword%2C%20golden%20and%20amber%20warm%20tones%2C%20epic%20composition%2C%20dynamic%20pose%2C%20dramatic%20lighting%20effects&width=500&height=700&seq=card-manga-02&orientation=portrait',
    title: '魔导纪元',
    tag: '日漫·奇幻',
    status: '连载中',
    update: '今日更新',
    desc: '少年觉醒远古魔力，热血冒险与深厚友情交织。战斗场面炸裂，剧情环环相扣。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20immortal%20cultivation%20character%20floating%20among%20clouds%20with%20traditional%20robes%2C%20warm%20golden%20sunset%20lighting%2C%20elegant%20composition%2C%20ink%20wash%20painting%20influence&width=500&height=700&seq=card-manga-03&orientation=portrait',
    title: '仙途无尽',
    tag: '国漫·仙侠',
    status: '连载中',
    update: '今日更新',
    desc: '凡尘少年偶得仙缘，一步步攀登修真巅峰。国风水墨融合现代漫画技法，匠心之作。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manga%20cover%20with%20mysterious%20mage%20character%20surrounded%20by%20floating%20ancient%20books%20and%20magical%20runes%2C%20warm%20amber%20glow%2C%20mystical%20atmosphere%2C%20gothic%20elements&width=500&height=700&seq=card-manga-04&orientation=portrait',
    title: '书灵奇缘',
    tag: '日漫·奇幻',
    status: '连载中',
    update: '昨日更新',
    desc: '古籍管理员发现书中世界真实存在，翻开每本书都是一次奇妙冒险。想象力炸裂。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20slice%20of%20life%20manga%20cover%20with%20a%20warm%20cafe%20scene%2C%20gentle%20sunlight%2C%20cats%20and%20pastries%2C%20healing%20atmosphere%2C%20soft%20cream%20and%20brown%20tones%2C%20comforting%20art%20style&width=500&height=700&seq=card-manga-05&orientation=portrait',
    title: '咖啡馆奇妙夜',
    tag: '韩漫·治愈',
    status: '已完结',
    update: '全集可看',
    desc: '深夜咖啡馆里，每位客人都带着自己的故事。温暖治愈的都市日常，心灵港湾。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20thrilling%20mystery%20manga%20cover%20with%20a%20detective%20character%20in%20a%20dark%20alley%2C%20warm%20streetlight%20glow%2C%20suspenseful%20atmosphere%2C%20noir%20style%2C%20dramatic%20shadows&width=500&height=700&seq=card-manga-06&orientation=portrait',
    title: '暗夜追踪者',
    tag: '国漫·悬疑',
    status: '连载中',
    update: '今日更新',
    desc: '连环案件背后隐藏惊天秘密，天才侦探与犯罪天才的巅峰对决。紧张刺激一追到底。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20Korean%20historical%20fantasy%20manhwa%20cover%20with%20a%20noble%20character%20in%20traditional%20hanbok%2C%20palace%20background%2C%20warm%20golden%20and%20red%20accents%2C%20dramatic%20and%20elegant%20composition&width=500&height=700&seq=card-manga-07&orientation=portrait',
    title: '宫廷秘史',
    tag: '韩漫·古风',
    status: '连载中',
    update: '今日更新',
    desc: '深宫之中权谋暗涌，小宫女如何逆袭成为一代贤后。华丽服饰与宫斗剧情双重暴击。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门连载</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网精选热门连载，韩漫日漫国漫每日更新追更不等待</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {cards.map((card) => (
            <div key={card.title} className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 flex flex-col group cursor-pointer">
              <div className="relative w-full aspect-[5/7] overflow-hidden">
                <img
                  src={card.img}
                  alt={`妖精漫画网 ${card.tag} - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-background-50 text-[11px] font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className={`px-2.5 py-1 text-[11px] font-medium rounded-full whitespace-nowrap ${card.status === '已完结' ? 'bg-accent-500/90 text-background-50' : 'bg-secondary-500/90 text-background-50'}`}>
                    {card.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/70 to-transparent p-3">
                  <span className="text-xs text-background-100">{card.update}</span>
                </div>
              </div>
              <div className="p-4 flex-1">
                <h3 className="font-heading text-base text-foreground-900 mb-1.5">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}